/**
 * @author: ritesh.dabral
 * 
 * This page returns the next and prev buttons for slider
 */

import PropTypes from 'prop-types'; 

// Slider Script Start
function SamplePrevArrow(props) {
    const { customClassName, customStyle, onClick, arrowIconClass } = props;
    return (
      <div
        className= {
            customClassName ? customClassName : "slider-icon"
        }
        style={{ ...customStyle}}
        onClick={onClick}
      >
        <i className={arrowIconClass ? arrowIconClass : "fa fa-angle-double-left"} aria-hidden="true" style={{ fontSize:'30px'}}></i>
      </div>
    );
  }
  
function SampleNextArrow(props) {
    const { customClassName, customStyle, onClick,arrowIconClass } = props;
    return (
      <div
        className={
            customClassName ? customClassName : "slider-icon "
        }
        style={{ ...customStyle}}
        onClick={onClick}
      >
        <i className={arrowIconClass ? arrowIconClass : "fa fa-angle-double-right"} aria-hidden="true" style={{ fontSize:'30px'}}></i>
      </div>
    );
  }
 // Slider script End  


 // proptype checking
 SamplePrevArrow.propTypes = {
    customClassName : PropTypes.string,
    style : PropTypes.object,
    onClick : PropTypes.func
 }

 SampleNextArrow.propTypes = {
    customClassName : PropTypes.string,
    style : PropTypes.object,
    onClick : PropTypes.func
 }

 const slickSliderArrows = {
  SamplePrevArrow,
  SampleNextArrow
}


 export default slickSliderArrows;